import { RouteConfig } from 'vue-router';
const Login = () => import('./views/login.vue');
const Register = () => import('./views/register.vue');
const routers: RouteConfig[] = [
    {
        path: 'login',
        name: 'login',
        component: Login
    },
    {
        path: 'register',
        name: 'register',
        component: Register
    },
    {
        path: '',
        redirect: 'login'
    },
];
export default routers;

